export const WEBSOCKET_ENDPOINT = {
    development: "ws://127.0.0.1:3000",
    staging: "wss://chat-js-websocket-staging-61b4c12861f0.herokuapp.com",
    production:
        "wss://chat-js-websocket-production-e38025290b76.herokuapp.com/",
    review_app:
        import.meta.env.VITE_WEBSOCKET_URL ||
        "wss://chat-js-websocket-d4ad03772452.herokuapp.com",
} as const;
